import { command, computed, state } from 'ccstate'
import type { ReactNode } from 'react'

const currentPage$ = state<ReactNode | undefined>(undefined)

export const page$ = computed((get) => {
  return get(currentPage$)
})

export const updatePage$ = command(({ set }, page: ReactNode) => {
  set(currentPage$, page)
})
